var render = function render(){var _vm=this,_c=_vm._self._c;return _c('l-layout',{attrs:{"layout":"xs12 sm10 md8"}},[_c('l-data-table',{attrs:{"hide-actions":"","hide-title":"","hide-headers":"","headers":[{text: '区域名称', value: 'name'}],"must-sort":false,"items":_vm.areaList}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }